import script from "./Projetos.vue?vue&type=script&setup=true&lang=js"
export * from "./Projetos.vue?vue&type=script&setup=true&lang=js"

import "./Projetos.vue?vue&type=style&index=0&id=3c3be375&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3be375"]])

export default __exports__